module.exports = __webpack_public_path__ + "img/img10.dccb715d.jpg";